module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAO1JREFUWEftmDESgjAQRV9uoKiX4GAyIw21NeMNsLDzUuohEDkBcZxBzUhiJgWBYmkpeLzd/GSjmNmjZsaDAPkqEtvQFjgAqx7sDuyB0xs0NtALIPmx1BiA0XtIO0r2ERPbkAD5FpEYEkM+A7734/ZQumszTVcqxbonaTtUcauWZwfZyEB58wAW5se1pr4ek81UQNY/vlSJK3BHNyRAf1dNmjdiaHJDGVDCN1eAArDmSoySDXIFqAFrrsQA8uaEWUMBMmxYk1cMiSEYzGWyyvq2cA6KocEYekALHqXDto7wI+zsLht8Q0D0ywYv0BPfp5YlwQxIMAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/share/14friendDesc/05tndj.png
// module id = HNHp
// module chunks = 0